import { Controller } from 'react-hook-form'

import { TCommonFields } from '../../types'
import { FieldRow, getFieldRules } from '../field-row'
import { useFieldState } from '../hooks'

export type TRadioField<T> = TCommonFields<T> & {
    type: 'radio'
    value: string
    checked?: boolean
}

type TProps<T> = {
    rowField: TRadioField<T>
    fieldName: string
    labelWidth?: string
}

const RadioField = <T,>({ rowField, fieldName, labelWidth }: TProps<T>) => {
    const { disabled, required } = useFieldState(rowField)
    const optionId = `${fieldName}-${rowField.value}`

    return (
        <FieldRow
            fieldName={fieldName}
            label={rowField.label}
            required={required}
            labelWidth={labelWidth}
            className="form-radio"
            htmlFor={optionId}
        >
            <Controller
                name={fieldName}
                rules={getFieldRules(rowField, required)}
                render={({ field: { value, onChange, ...props } }) => (
                    <input
                        {...props}
                        id={optionId}
                        onChange={e => {
                            onChange(e)
                            rowField.onChange?.(e.target.value)
                        }}
                        value={rowField.value}
                        type="radio"
                        required={required}
                        disabled={disabled}
                        // `rowField.checked` only picks the default (see generateDefaultValues)
                        checked={value == rowField.value}
                    />
                )}
            />
        </FieldRow>
    )
}

export default RadioField
